import { render, staticRenderFns } from "./ReportScreen.vue?vue&type=template&id=8cfb1536&scoped=true"
import script from "./ReportScreen.vue?vue&type=script&lang=js"
export * from "./ReportScreen.vue?vue&type=script&lang=js"
import style0 from "./ReportScreen.vue?vue&type=style&index=0&id=8cfb1536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfb1536",
  null
  
)

export default component.exports